import React from "react";

function Electronics({ bikeone, biketwo }) {
    return (
        <div className="bg-white compare-specs rounded p-3">
            <h5>Specifications</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Name</td>
                            <td className="bg-light text-danger fw-bold">{bikeone?.title}</td>
                            <td className="bg-light text-danger fw-bold">{biketwo?.title}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Product Type</td>
                            <td>{bikeone?.electronicspecification?.product_type}</td>
                            <td>{biketwo?.electronicspecification?.product_type}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Certification</td>
                            <td>{bikeone?.electronicspecification?.certification}</td>
                            <td>{biketwo?.electronicspecification?.certification}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Color Options</td>
                            <td>{bikeone?.electronicspecification?.color_option}</td>
                            <td>{biketwo?.electronicspecification?.color_option}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Connectivity Option</td>
                            <td>{bikeone?.electronicspecification?.connectivity_option}</td>
                            <td>{biketwo?.electronicspecification?.connectivity_option}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Control Type</td>
                            <td>{bikeone?.electronicspecification?.control_type}</td>
                            <td>{biketwo?.electronicspecification?.control_type}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Country/Origin</td>
                            <td>{bikeone?.electronicspecification?.country_of_origin}</td>
                            <td>{biketwo?.electronicspecification?.country_of_origin}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Dimension</td>
                            <td>{bikeone?.electronicspecification?.dimension}</td>
                            <td>{biketwo?.electronicspecification?.dimension}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Display</td>
                            <td>{bikeone?.electronicspecification?.display}</td>
                            <td>{biketwo?.electronicspecification?.display}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Energy Rating</td>
                            <td>{bikeone?.electronicspecification?.energy_rating}</td>
                            <td>{biketwo?.electronicspecification?.energy_rating}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Frequency</td>
                            <td>{bikeone?.electronicspecification?.frequency}</td>
                            <td>{biketwo?.electronicspecification?.frequency}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Function</td>
                            <td>{bikeone?.electronicspecification?.function}</td>
                            <td>{biketwo?.electronicspecification?.function}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Included Accessory</td>
                            <td>{bikeone?.electronicspecification?.included_accessory}</td>
                            <td>{biketwo?.electronicspecification?.included_accessory}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Material</td>
                            <td>{bikeone?.electronicspecification?.material}</td>
                            <td>{biketwo?.electronicspecification?.material}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Weight</td>
                            <td>{bikeone?.electronicspecification?.weight}</td>
                            <td>{biketwo?.electronicspecification?.weight}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Model Number</td>
                            <td>{bikeone?.electronicspecification?.model_number}</td>
                            <td>{biketwo?.electronicspecification?.model_number}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Noise Level</td>
                            <td>{bikeone?.electronicspecification?.noise_level}</td>
                            <td>{biketwo?.electronicspecification?.noise_level}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Operating Temperature</td>
                            <td>{bikeone?.electronicspecification?.operating_temperature}</td>
                            <td>{biketwo?.electronicspecification?.operating_temperature}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Power Consumption</td>
                            <td>{bikeone?.electronicspecification?.power_consumption}</td>
                            <td>{biketwo?.electronicspecification?.power_consumption}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Safety Feature</td>
                            <td>{bikeone?.electronicspecification?.safety_feature}</td>
                            <td>{biketwo?.electronicspecification?.safety_feature}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Voltage Requirement</td>
                            <td>{bikeone?.electronicspecification?.voltage_requirement}</td>
                            <td>{biketwo?.electronicspecification?.voltage_requirement}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Warranty</td>
                            <td>{bikeone?.electronicspecification?.warranty}</td>
                            <td>{biketwo?.electronicspecification?.warranty}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Electronics;